export const FIXED_HEIGHT = {
  d: 48,
  m: 32,
};
